module.exports = __webpack_public_path__ + "static/media/team2.9f6b2284.jpg";